import {
  Checkbox,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AlertBox from "../../component/AlertBox";
import axios from "axios";
import { SERVER_URL } from "../../constant";
import ButtonCompo from "../../component/ButtonCompo";
import { MdDelete } from "react-icons/md";
import DialogBox from "../../component/DialogBox";
import { MobileTimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";

function TeamMembers() {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [membersData, setMembersData] = useState([]);
  const [selectedMember, setSelectedmember] = useState([]);
  const [startShift, setStartShift] = useState();
  const [endShift, setEndShift] = useState();
  const [reload, setReload] = useState(false);

  const label = { inputProps: { "aria-label": "Checkbox demo" } };

  // fetch members
  async function getTeamMembers() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/get/team/members`,
        method: "get",
        withCredentials: true,
      });
      const rawData = res.data?.data?.team;
      console.log(res.data?.data?.team)
      setMembersData(rawData);
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage("Members fetch failed");
    } finally {
      setLoading(false);
    }
  }

  async function changeShift() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/change/shift`,
        method: "post",
        data: {
          userArray: selectedMember,
          startShift: dayjs(startShift).format("h:mm A"),
          endShift: dayjs(endShift).format("h:mm A"),
        },
        withCredentials: true,
      });
      setReload((prev) => !prev);
      setOpen(true);
      setSuccess(true);
      setMessage("Shift has been changed");
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Shift change failed");
    } finally {
      setLoading(false);
    }
  }

  // select and unselect member
  function selectUser(status, userData) {
    if (status) {
      setSelectedmember((prev) => [...prev, userData?._id]);
    } else {
      setSelectedmember((prev) => {
        const newArr = prev.filter((id) => id !== userData?._id);
        return newArr;
      });
    }
  }

  useEffect(() => {
    getTeamMembers();
  }, [reload]);

  console.log(selectedMember);

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center items-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] py-5">
          <h1 className="text-[30px] font-medium text-left w-full">
            Team Members
          </h1>
          {selectedMember?.length > 0 ? (
            <div className="w-full p-3 bg-blue-200/90 mt-5 flex justify-between items-center">
              <section className="flex justify-center items-center gap-3">
                <span className="text-slate-700">
                  {selectedMember?.length} selected
                </span>
                <button onClick={() => setSelectedmember([])}>
                  <MdDelete size={"25px"} className="text-slate-500" />
                </button>
              </section>
              <section className="flex justify-center items-center gap-2">
                <DialogBox
                  trigger={<ButtonCompo>Change Shift</ButtonCompo>}
                  title="Change Shift"
                  actionButton={
                    <ButtonCompo onClick={changeShift}>Save</ButtonCompo>
                  }
                  closeActionButton="Cancel"
                >
                  <div className="grid grid-cols-2 gap-2">
                    <MobileTimePicker
                      label="Clock In"
                      onChange={setStartShift}
                    />
                    <MobileTimePicker
                      label="Clock Out"
                      onChange={setEndShift}
                    />
                  </div>
                </DialogBox>
              </section>
            </div>
          ) : (
            ""
          )}
          <div className="mt-5 w-full">
            <Table>
              <TableHead>
                <TableRow className="bg-blue-500">
                  <TableCell className="!text-center !text-white">
                    Check
                  </TableCell>
                  <TableCell className="!text-center !text-white">
                    Employee ID
                  </TableCell>
                  <TableCell className="!text-center !text-white">
                    Name
                  </TableCell>
                  <TableCell className="!text-center !text-white">
                    Role
                  </TableCell>
                  <TableCell className="!text-center !text-white">
                    Email
                  </TableCell>
                  <TableCell className="!text-center !text-white">
                    Phone Number
                  </TableCell>
                  <TableCell className="!text-center !text-white">
                    Start Shift
                  </TableCell>
                  <TableCell className="!text-center !text-white">
                    End Shift
                  </TableCell>
                  <TableCell className="!text-center !text-white">
                    More
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody className="!border">
                {membersData?.map((e, i) => (
                  <TableRow>
                    <TableCell className="!text-center">
                      <Checkbox
                        checked={selectedMember?.some((id) => id === e?._id)}
                        onChange={(event) =>
                          selectUser(event.target.checked, e)
                        }
                      />
                    </TableCell>
                    <TableCell className="!text-center">
                      <span className="bg-blue-100 text-blue-800 text-[14px] font-medium px-3 py-1 rounded-full">
                        {e?.employeeId}
                      </span>
                    </TableCell>
                    <TableCell className="!text-center">
                      {e?.fullName}
                    </TableCell>
                    <TableCell className="!text-center">{e?.role}</TableCell>
                    <TableCell className="!text-center">
                      {e?.profEmail}
                    </TableCell>
                    <TableCell className="!text-center">
                      {e?.phoneNumber}
                    </TableCell>
                    <TableCell className="!text-center">
                      {e?.startShieftTime}
                    </TableCell>
                    <TableCell className="!text-center">
                      {e?.endShieftTime}
                    </TableCell>
                    <TableCell className="!text-center">
                      <ButtonCompo href={`/admin/team/member/${e?._id}`}>More</ButtonCompo>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </div>
      </div>
    </>
  );
}

export default TeamMembers;
